(()=>{
 'use strict';
 const $=(q,root=document)=>root.querySelector(q),$$=(q,root=document)=>[...root.querySelectorAll(q)];
 const header=$('#site-header'),overlay=$('.site-overlay');if(!header||!overlay)return;
 const body=document.body,navigation=$('#site-navigation'),panel=$('#site-panel'),main=$('#site-main')||$('#MainContent')||$('main'),footer=$('.site-footer');
 const cart=null,cartClose=$('.site-cart-close'),cartTriggers=$$('[data-site-cart]'),nativeCart=document.getElementById('CartDrawer');
 const menu=$('.site-menu-toggle'),nav=$('.site-nav'),announcement=$('.site-announcement'),searchLaunch=$('.site-search-launch');
 const back=$('.site-panel-back'),views=$$('[data-menu-view]');
 const mobile=matchMedia('(max-width:1000px)'),small=matchMedia('(max-width:760px)'),motion=matchMedia('(prefers-reduced-motion:reduce)');
 const hoverPointer=matchMedia('(any-hover:hover) and (any-pointer:fine)');
 let hoverOpenTimer=0,hoverCloseTimer=0,hoverOwned=false;
 const reduced=()=>motion.matches||body.classList.contains('is-reduced');
 let storyPlaying=$('.play-scene')?.getAttribute('aria-pressed')==='true';
 let lastCategory=$('.site-nav [data-menu]')?.dataset.menu||'shop';
 let opened=false,view='root',compact=scrollY>32,returnFocus=null,closingTimer=0,openingFrame=0,scrollFrame=0,viewAnimations=[],viewTimer=0,viewHistory=[];
 // Show the desktop category row on initial load; scroll can still compact it.
 let topNavigationRevealed=true;
 let headerState='';
 let chatHolding=false,quickHolding=false,navHolding=false,cartOpen=false,cartHolding=false,nativeHolding=false,overlayPaused=false,cartReturn=null,cartTimer=0,cartFrame=0;
 const searchInput=$('#site-search-input'),results=$('.site-search-results'),status=$('.site-search-status');
 function updateHeader(){
  // Keep phone height fixed and never tie header geometry to playback state.
  if(scrollY>32)topNavigationRevealed=true;
  const next=navHolding||(!mobile.matches&&!topNavigationRevealed)||scrollY>32||(compact&&scrollY>8);
  compact=next;
  const state=[next,navHolding,mobile.matches,announcement.hidden].join('/');
  if(state===headerState)return;headerState=state;
  body.classList.toggle('is-site-compact',next);
  nav.inert=mobile.matches||(next&&!navHolding);announcement.inert=announcement.hidden||next||mobile.matches;
  menu.inert=!next&&!mobile.matches;
  const cleanSheet=navHolding&&mobile.matches;
  body.classList.toggle('has-site-menu',navHolding);
  $('.site-brand').inert=cleanSheet;$('.site-utilities').inert=cleanSheet;
  searchLaunch.inert=cleanSheet;
  
 }
 function alignNavToSearch(){
  if(mobile.matches||!nav||!searchLaunch)return;
  const first=nav.firstElementChild;if(!first)return;
  const textInset=parseFloat(getComputedStyle(first).paddingLeft)||0;
  const offset=Math.max(0,searchLaunch.getBoundingClientRect().left-nav.getBoundingClientRect().left-textInset);
  nav.style.setProperty('--site-nav-inset',offset+'px');
 }
 function syncShell(){
  const busy=navHolding||cartHolding||nativeHolding||quickHolding||chatHolding;
  body.classList.toggle('has-site-overlay',busy);if(main)main.inert=busy;if(footer)footer.inert=busy;
  // The header close, search and cart controls belong to the navigation dialog.
  // Only a cart in front of that dialog disables the navigation as a whole.
  header.inert=false;navigation.inert=cartHolding||nativeHolding||quickHolding||chatHolding;
  if(busy!==overlayPaused){overlayPaused=busy;document.dispatchEvent(new CustomEvent('site:overlay',{detail:{open:busy}}))}
 }
 function focusable(root=navigation){
  return $$('a[href],button,input,select,summary,[tabindex]',root).filter(el=>!el.disabled&&el.tabIndex!==-1&&!el.closest('[hidden],[inert]')&&el.getClientRects().length);
 }
 function restoreFocus(target,fallback=menu){
  const usable=el=>el&&!el.closest('[hidden],[inert]')&&el.getClientRects().length;
  (usable(target)?target:usable(fallback)?fallback:$('.site-brand')).focus({preventScroll:true});
 }
 function focusView(key){
  if(key==='search'){searchInput.focus({preventScroll:true});return}
  const first=$('[data-menu-view="'+key+'"] a, [data-menu-view="'+key+'"] button');
  (first||menu).focus({preventScroll:true});
 }
 function clearViewTransition(){
  clearTimeout(viewTimer);viewAnimations.forEach(a=>a.cancel());viewAnimations=[];
  views.forEach(el=>{el.hidden=el.dataset.menuView!==view;el.inert=el.hidden});
 }
 function setView(key,focus=true,direction=1){
  if(!views.some(el=>el.dataset.menuView===key))return;
  const old=view,incoming=views.find(el=>el.dataset.menuView===key);
  // Capture all visible layers before cancellation, including a rapid reversal.
  const snapshots=views.filter(el=>!el.hidden).map(el=>{const css=getComputedStyle(el);return {el,opacity:parseFloat(css.opacity)||0,transform:css.transform||'none'}});
  const arriving=snapshots.find(s=>s.el===incoming);
  clearViewTransition();view=key;
  if(key!=='root'&&key!=='search')lastCategory=key;
  views.forEach(el=>{el.hidden=el!==incoming;el.inert=el!==incoming});
  back.hidden=!viewHistory.length;overlay.classList.toggle('has-menu-history',viewHistory.length>0);back.setAttribute('aria-label','Back to '+(viewHistory.at(-1)?.key==='root'?'main menu':(viewHistory.at(-1)?.key||'main')+' menu'));panel.setAttribute('aria-label',key==='search'?'Search Tech Tool':key==='root'?'Main menu':key[0].toUpperCase()+key.slice(1)+' menu');
  $$('[data-menu]').forEach(el=>el.setAttribute('aria-expanded',String(opened&&el.dataset.menu===key)));
  searchLaunch.setAttribute('aria-expanded',String(opened&&key==='search'));
  panel.scrollTop=0;
  if(opened&&overlay.classList.contains('is-open')&&old!==key&&!reduced()&&incoming.animate){
   const options={duration:300,easing:'cubic-bezier(.22,1,.36,1)',fill:'both'};
   snapshots.filter(s=>s.el!==incoming).forEach(s=>{
    s.el.hidden=false;s.el.inert=true;
    viewAnimations.push(s.el.animate([{opacity:s.opacity,transform:s.transform},{opacity:0,transform:'translateX('+(-direction*8)+'px)'}],options));
   });
   viewAnimations.push(incoming.animate([{opacity:arriving?.opacity||0,transform:arriving?.transform||'translateX('+(direction*12)+'px)'},{opacity:1,transform:'translateX(0)'}],options));
   viewTimer=setTimeout(clearViewTransition,310);
  }
  overlay.classList.toggle('is-search-view',key==='search');
  if(key==='search')renderSearch();else document.dispatchEvent(new CustomEvent('site:search-close'));
  if(focus)focusView(key);
 }
 function openMenu(key='root',trigger=document.activeElement,fromHover=false){
  clearHoverTimers();
  if(cartHolding||nativeHolding||quickHolding||chatHolding)return;
  // Keep explicit ownership when switching categories in an already open menu.
  hoverOwned=fromHover&&!(opened&&!hoverOwned);
  if(!mobile.matches&&key==='root')key=lastCategory;
  if(opened&&key===view){if(trigger?.closest('.site-nav'))returnFocus=trigger;if(!fromHover)focusView(view);return}
  clearTimeout(closingTimer);cancelAnimationFrame(openingFrame);
  const firstPaint=overlay.hidden;
  if(!opened){
   viewHistory=[];
   returnFocus=trigger;opened=true;overlay.hidden=false;overlay.inert=false;
   navHolding=true;navigation.setAttribute('role','dialog');navigation.setAttribute('aria-modal','true');navigation.setAttribute('aria-label','Navigation');syncShell();
  }
  else if(key!==view){
   // Primary categories are peers. Switch in place without creating a Back trail.
   if(!mobile.matches||trigger?.closest('.site-nav')){viewHistory=[];returnFocus=trigger}
   else viewHistory.push({key:view,trigger});
  }
  updateHeader();menu.setAttribute('aria-expanded','true');menu.setAttribute('aria-label','Close menu');
  setView(key,!fromHover);
  // Materialize the hidden-to-visible start state once on opening. This avoids
  // first-open transitions being skipped when style changes land in one frame.
  if(firstPaint&&!reduced())void getComputedStyle(panel).opacity;
  openingFrame=requestAnimationFrame(()=>{openingFrame=0;if(opened)overlay.classList.add('is-open')});
 }
 function syncMenuLayout(){
  clearHoverTimers();hoverOwned=false;
  if(navHolding){
   // Desktop already exposes every category. Mobile needs a route back to its list.
   if(mobile.matches){
    if(view!=='root'&&!viewHistory.length)viewHistory=[{key:'root',trigger:$('[data-menu-view="root"] [data-menu="'+lastCategory+'"]')}];
   }else viewHistory=[];
   setView(!mobile.matches&&view==='root'?lastCategory:view,false);
   clearViewTransition();
  }
  updateHeader();
  if(opened&&document.activeElement?.closest('[hidden],[inert]'))focusView(view);
 }
 function closeMenu(restore=true,immediate=false){
  clearHoverTimers();hoverOwned=false;
  if(!opened&&!navHolding)return;
  opened=false;document.dispatchEvent(new CustomEvent('site:search-close'));cancelAnimationFrame(openingFrame);
  overlay.classList.remove('is-open');overlay.inert=true;
  menu.setAttribute('aria-expanded','false');menu.setAttribute('aria-label','Open menu');
  $$('[data-menu]').forEach(el=>el.setAttribute('aria-expanded','false'));searchLaunch.setAttribute('aria-expanded','false');
  updateHeader();clearTimeout(closingTimer);
  const finishClose=()=>{
   if(opened)return;
   overlay.hidden=true;clearViewTransition();navHolding=false;viewHistory=[];back.hidden=true;overlay.classList.remove('has-menu-history');updateHeader();
   navigation.removeAttribute('role');navigation.removeAttribute('aria-modal');navigation.removeAttribute('aria-label');syncShell();
   if(restore&&!cartHolding&&!nativeHolding)restoreFocus(returnFocus);
  };
  if(immediate){
   // Link and chat handoffs need the final header geometry synchronously.
   // Its height transition otherwise leaves anchor offsets at the menu height.
   const transition=header.style.transition;header.style.transition='none';
   finishClose();body.style.setProperty('--header-height',Math.round(header.getBoundingClientRect().height)+'px');
   header.style.transition=transition;
  }else if(reduced())finishClose();else closingTimer=setTimeout(finishClose,280);
 }
 function closeCart(restore=true){
  if(!cartOpen)return;
  cartOpen=false;cancelAnimationFrame(cartFrame);cart.classList.remove('is-open');cart.inert=true;
  cartTriggers.forEach(el=>el.setAttribute('aria-expanded','false'));clearTimeout(cartTimer);
  const finish=()=>{if(!cartOpen){cart.hidden=true;cartHolding=false;syncShell();if(restore)restoreFocus(cartReturn,$('.site-cart-toggle'))}};
  if(reduced())finish();else cartTimer=setTimeout(finish,300);
 }
 function openCart(trigger){
  // Call the existing theme controller when integrated into Shopify. Do not
  // replace its cart state, quantity updates, checkout or focus management.
  if(nativeCart){
   if(typeof nativeCart.show!=='function')return false;
   if(nativeCart.open){nativeCart.hide();return true}
   nativeHolding=true;closeMenu(false,true);syncShell();
   try{nativeCart.show(trigger.closest('[hidden],[inert]')?$('.site-cart-toggle'):trigger,!reduced())}catch(error){nativeHolding=false;syncShell();return false}
   if(!nativeCart.open){nativeHolding=false;syncShell();return false}
   return true;
  }
  if(cartOpen){closeCart();return true}
  if(!cart)return false;
  const firstPaint=cart.hidden;
  clearTimeout(cartTimer);cancelAnimationFrame(cartFrame);cartReturn=trigger;cartOpen=true;cartHolding=true;
  closeMenu(false,true);cart.hidden=false;cart.inert=false;syncShell();
  cartTriggers.forEach(el=>el.setAttribute('aria-expanded','true'));
  cartClose.focus({preventScroll:true});
  if(firstPaint&&!reduced())void getComputedStyle($('.site-cart-panel')).transform;
  cartFrame=requestAnimationFrame(()=>{cartFrame=0;if(cartOpen)cart.classList.add('is-open')});
  return true;
 }
 cartTriggers.forEach(el=>{
  if(nativeCart)el.setAttribute('aria-controls','CartDrawer');
  el.addEventListener('click',e=>{
   if(e.button>0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey){if(nativeCart)e.stopImmediatePropagation();return}
   if(openCart(el)){e.preventDefault();e.stopImmediatePropagation()}
  },true);
 });
 cartClose?.addEventListener('click',()=>closeCart());$('.site-cart-backdrop')?.addEventListener('click',()=>closeCart());
 $('.site-cart-continue')?.addEventListener('click',()=>closeCart());
 $('.site-cart-store')?.addEventListener('click',()=>closeCart(false));
 if(nativeCart){
  if(nativeCart.open){nativeHolding=true;syncShell()}
  nativeCart.addEventListener('toggle',e=>{if(e.target===nativeCart&&nativeCart.open){nativeHolding=true;closeMenu(false,true);syncShell()}});
  nativeCart.addEventListener('drawer:handleAfterHide',e=>{if(e.target===nativeCart&&!nativeCart.open){nativeHolding=false;syncShell()}});
 }
 // Hover is an enhancement for actual mouse/trackpad events, never simulated
 // touch hover. Explicit clicks and keyboard use own the menu until dismissed.
 function clearHoverTimers(){clearTimeout(hoverOpenTimer);clearTimeout(hoverCloseTimer);hoverOpenTimer=hoverCloseTimer=0}
 function canHover(e){return !mobile.matches&&hoverPointer.matches&&e.pointerType==='mouse'}
 function queueHoverClose(e){
  if(!canHover(e))return;
  clearHoverTimers();
  if(!hoverOwned||!opened||view==='search')return;
  if(e.relatedTarget instanceof Node&&(header.contains(e.relatedTarget)||panel.contains(e.relatedTarget)))return;
  hoverCloseTimer=setTimeout(()=>{
   hoverCloseTimer=0;
   if(hoverOwned&&opened&&!header.matches(':hover')&&!panel.matches(':hover'))closeMenu(panel.contains(document.activeElement));
  },320);
 }
 $$('.site-nav [data-menu]').forEach(el=>{
  el.addEventListener('pointerenter',e=>{
   if(!canHover(e)||navigation.inert||nav.inert||(opened&&view==='search')||navigation.classList.contains('is-keyboard'))return;
   clearHoverTimers();
   if(opened&&view===el.dataset.menu)return;
   hoverOpenTimer=setTimeout(()=>{
    hoverOpenTimer=0;
    if(el.matches(':hover')&&!nav.inert&&!navigation.inert)openMenu(el.dataset.menu,el,true);
   },180);
  });
  el.addEventListener('pointerleave',()=>{clearTimeout(hoverOpenTimer);hoverOpenTimer=0});
 });
 [header,panel].forEach(el=>{
  el.addEventListener('pointerenter',e=>{if(canHover(e))clearHoverTimers()});
  el.addEventListener('pointerleave',queueHoverClose);
 });
 hoverPointer.addEventListener('change',()=>{clearHoverTimers();hoverOwned=false});
 addEventListener('blur',()=>{clearHoverTimers();if(hoverOwned)closeMenu(false)});
 menu.addEventListener('pointerenter',e=>{
  if(!canHover(e)||navigation.inert||opened||navigation.classList.contains('is-keyboard'))return;
  clearHoverTimers();
  // Explicit ownership keeps the menu open after the pointer leaves.
  openMenu('root',menu,true);
  hoverOwned=false;
 });
 menu.addEventListener('click',()=>opened?closeMenu():openMenu('root',menu));
 $$('[data-menu]').forEach(el=>{if(el.matches('.site-nav a[href]'))return;el.addEventListener('click',()=>openMenu(el.dataset.menu,el))});
 [searchLaunch,$('.site-search-icon')].forEach(el=>el.addEventListener('click',()=>openMenu('search',el)));
 $('.site-backdrop').addEventListener('click',()=>closeMenu());
 back.addEventListener('click',()=>{const previous=viewHistory.pop();if(!previous)return;setView(previous.key,false,-1);restoreFocus(previous.trigger,menu)});
 if(!$('.journey'))$('.site-brand').setAttribute('href','/');
 $('.site-brand').addEventListener('click',e=>{if(!$('.journey'))return;e.preventDefault();closeMenu(false);scrollTo({top:0,behavior:reduced()?'instant':'smooth'})});
 $('.site-account').addEventListener('click',()=>closeMenu(false));
 overlay.addEventListener('click',e=>{
  if(e.defaultPrevented||e.target.closest('[data-search-quick-add]'))return;
  const link=e.target.closest('a[href]');if(!link)return;
  // Release the mobile sheet and restore the real header height before an
  // anchor calculates its destination. Delayed closing used the 56px menu header.
  closeMenu(false,true);
 });
 document.addEventListener('pointerdown',()=>{clearHoverTimers();hoverOwned=false;navigation.classList.remove('is-keyboard');cart?.classList.remove('is-keyboard')},true);
 document.addEventListener('keydown',e=>{
  clearHoverTimers();hoverOwned=false;
  if(['Tab','Enter',' ','ArrowUp','ArrowDown','ArrowLeft','ArrowRight'].includes(e.key)&&!e.metaKey&&!e.ctrlKey&&!e.altKey){navigation.classList.add('is-keyboard');cart?.classList.add('is-keyboard')}
  if(nativeHolding||(!opened&&!cartOpen))return;
  if(e.key==='Escape'){e.preventDefault();e.stopPropagation();if(cartOpen)closeCart();else closeMenu();return}
  if(e.key!=='Tab')return;
  const boundary=cartOpen?cart:navigation,all=focusable(boundary),first=all[0],last=all[all.length-1];
  if(!first){e.preventDefault();(cartOpen?cartClose:menu).focus();return}
  // Step explicitly so Safari also visits links when full keyboard access is off.
  const index=all.indexOf(document.activeElement);
  const next=index<0?(e.shiftKey?all.length-1:0):(index+(e.shiftKey?-1:1)+all.length)%all.length;
  e.preventDefault();all[next].focus({preventScroll:false});
 });
 function renderSearch(){document.dispatchEvent(new CustomEvent('site:search-open'))}
 $('.site-search-form').addEventListener('submit',e=>{if(!e.defaultPrevented&&searchInput.value.trim())closeMenu(false)});
 addEventListener('scroll',()=>{if(!scrollFrame)scrollFrame=requestAnimationFrame(()=>{scrollFrame=0;updateHeader()})},{passive:true});
 const tabs=$$('.family-tabs [role=tab]'),panels=$$('.family-panel');
 function selectTab(index,focus=false){
  tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;panels[i].hidden=i!==index});
  if(focus){tabs[index].focus({preventScroll:true});tabs[index].scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'})}
  requestAnimationFrame(updateRails);
 }
 tabs.forEach((tab,i)=>{
  tab.addEventListener('click',()=>selectTab(i));
  tab.addEventListener('keydown',e=>{
   let index=i;if(e.key==='ArrowRight')index=(i+1)%tabs.length;else if(e.key==='ArrowLeft')index=(i+tabs.length-1)%tabs.length;else if(e.key==='Home')index=0;else if(e.key==='End')index=tabs.length-1;else return;
   e.preventDefault();e.stopPropagation();selectTab(index,true);
  });
 });
 const rails=$$('.shop-product-rail');
 function railButtons(rail){return $$('[data-rail-direction][aria-controls="'+rail.id+'"]')}
 function updateRail(rail){
  const max=Math.max(0,rail.scrollWidth-rail.clientWidth);
  railButtons(rail).forEach(button=>button.disabled=+button.dataset.railDirection<0?rail.scrollLeft<=2:rail.scrollLeft>=max-2);
  const progress=document.querySelector('[data-rail-progress="'+rail.id+'"]');
  if(progress)progress.style.transform='scaleX('+(max?Math.max(0,Math.min(1,rail.scrollLeft/max)):1)+')';
 }
 function updateRails(){rails.forEach(updateRail)}
 function moveRail(rail,direction){
  const positions=[...rail.children].map(el=>el.offsetLeft-rail.children[0].offsetLeft);
  const max=Math.max(0,rail.scrollWidth-rail.clientWidth),x=rail.scrollLeft;
  const next=direction>0?positions.find(p=>p>x+3):positions.reverse().find(p=>p<x-3);
  rail.scrollTo({left:Math.max(0,Math.min(max,next??(direction>0?max:0))),behavior:reduced()?'instant':'smooth'});
 }
 $$('[data-rail-direction]').forEach(button=>button.addEventListener('click',()=>moveRail(document.getElementById(button.getAttribute('aria-controls')),+button.dataset.railDirection)));
 rails.forEach(rail=>{
  let frame=0;rail.addEventListener('scroll',()=>{if(!frame)frame=requestAnimationFrame(()=>{frame=0;updateRail(rail)})},{passive:true});
  rail.addEventListener('keydown',e=>{
   if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;
   e.preventDefault();e.stopPropagation();
   if(e.key==='Home'||e.key==='End')rail.scrollTo({left:e.key==='Home'?0:rail.scrollWidth,behavior:reduced()?'instant':'smooth'});
   else moveRail(rail,e.key==='ArrowRight'?1:-1);
  });
 });
 // Keep keyboard browsing in the store independent from the story's arrow shortcuts.
 $('.storefront-content')?.addEventListener('keydown',e=>{if(['ArrowLeft','ArrowRight'].includes(e.key))e.stopPropagation()});
 const details=$$('.site-footer-columns details');
 function footerMode(){details.forEach(el=>{el.open=!small.matches;el.querySelector('summary').tabIndex=small.matches?0:-1})}
 details.forEach(el=>el.querySelector('summary').addEventListener('click',e=>{if(!small.matches)e.preventDefault()}));
 document.addEventListener('site:close-menu',()=>closeMenu(false,true));
 document.addEventListener('site:chat',e=>{chatHolding=!!e.detail.open;if(chatHolding)closeMenu(false,true);syncShell()});
 document.addEventListener('site:quick-add',e=>{quickHolding=!!e.detail.open;syncShell()});
 document.addEventListener('site:playback',e=>{storyPlaying=e.detail.playing;updateHeader()});
 motion.addEventListener('change',updateHeader);
 mobile.addEventListener('change',syncMenuLayout);small.addEventListener('change',footerMode);
 addEventListener('resize',()=>{updateHeader();updateRails()},{passive:true});
 if(typeof ResizeObserver!=='undefined'){
  const observer=new ResizeObserver(updateRails);rails.forEach(rail=>observer.observe(rail));
 }
 const headerObserver=new ResizeObserver(()=>{
  body.style.setProperty('--header-height',Math.round(header.getBoundingClientRect().height)+'px');
  alignNavToSearch();
 });
 headerObserver.observe(header);headerObserver.observe(searchLaunch);
 updateHeader();alignNavToSearch();footerMode();updateRails();
 if(document.fonts?.ready)document.fonts.ready.then(()=>{updateHeader();alignNavToSearch()});
 addEventListener('pageshow',()=>{updateHeader();alignNavToSearch()});
})();

